
$(document).ready(function() {
    $( ".table-icon" ).on( "mouseenter", function() {
    let change = $(this).data('change');
    $(this).attr('src',change);
  }).on( "mouseleave", function() {
    let init = $(this).data('init');
    $(this).attr('src',init);
  });

  $('#view-search').on('click',function (event) {
      event.preventDefault();
      if($(this).attr('data-state') == 'open') {
          $(this).attr('data-state', 'closed');
          $('#search-container').removeClass('d-flex').addClass('d-none');
      }else{
          $(this).attr('data-state', 'open');
          $('#search-container').removeClass('d-none').addClass('d-flex');
      }
  });

    /*var currentUrl = window.location.pathname;
    $('.components .nav-link').each(function() {
        console.log($(this).attr('href'));
        var linkUrl = $(this).attr('href');
        $(this).parent('li').removeClass('active');
        if (currentUrl.includes(linkUrl)) {
            $(this).parent('li').addClass('active');
        }
        if(currentUrl.includes('request-detail-1.html')) {
            $('.components a[href="request.html"]').parent('li').addClass('active');
        }
    });*/

});

$(document).ready(function () {
    // Función para abrir/cerrar el dropdown solo en dispositivos móviles
    function handleDropdown() {
        // Verifica si la ventana es menor que 768px (ancho típico para dispositivos móviles)
        if ($(window).width() < 768) {
            // Abrir dropdown al hacer clic en el botón
            $('#dropdownMenuButton1').on('click', function (e) {
                e.stopPropagation(); // Evita que el clic en el botón cierre el menú
                $(this).next('.dropdown-menu').toggleClass('show');
            });

            // Cerrar dropdown al hacer clic fuera del dropdown
            $(document).on('click', function (e) {
                if (!$(e.target).closest('#dropdownMenuButton1').length) {
                    $('.dropdown-menu').removeClass('show');
                }
            });
        } else {
            // Eliminar los eventos cuando no es móvil
            $('#dropdownMenuButton1').off('click');
            $(document).off('click');
            $('.dropdown-menu').removeClass('show'); // Asegúrate de que esté cerrado
        }
    }

    // Llama a la función al cargar la página
    handleDropdown();

    // Llama a la función cuando se redimensiona la ventana
    $(window).resize(function () {
        handleDropdown();
    });
});
